var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.59246 2.40292C8.33959 2.8852 8.86348 3.70133 8.95886 4.64867C9.26356 4.79525 9.60174 4.87954 9.96027 4.87954C11.2692 4.87954 12.3301 3.78729 12.3301 2.43987C12.3301 1.09225 11.2692 0 9.96027 0C8.66384 0.000415227 7.61222 1.07315 7.59246 2.40292ZM4.03993 7.39851C5.34886 7.39851 6.40976 6.30605 6.40976 4.95864C6.40976 3.61123 5.34866 2.51897 4.03993 2.51897C2.7312 2.51897 1.66969 3.61144 1.66969 4.95885C1.66969 6.30626 2.7312 7.39851 4.03993 7.39851ZM5.04517 7.56481H4.03973H3.03428C1.36116 7.56481 0 8.96641 0 10.689V13.2208L0.00625122 13.2605L0.17564 13.3151C1.77233 13.8287 3.15951 14 4.30127 14C6.53136 14 7.82396 13.3454 7.90361 13.3037L8.06191 13.2212H8.07885V10.689C8.07945 8.96641 6.71829 7.56481 5.04517 7.56481ZM10.9659 5.04605H8.97056C8.94898 5.86799 8.60819 6.60813 8.06917 7.14045C9.55636 7.59575 10.6445 9.01562 10.6445 10.6927V11.4729C12.6146 11.3986 13.75 10.8237 13.8248 10.7851L13.9831 10.7025H14V8.1698C14 6.44744 12.6388 5.04605 10.9659 5.04605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.e5b19b81.svg";
export { ForwardRef as ReactComponent };